// ==============================|| PHONE FORMATTING ||============================== //
// core_users.phone je volný text bez masky/validace (uživatel si ho zadá
// jakkoliv) - tyhle dvě funkce z toho udělají jednotný zobrazovaný tvar
// ("+420 123 456 789") a čistou hodnotu pro `tel:` odkaz (2026-08-29, na
// výslovné přání uživatele - "aby šlo kliknout a telefonovat"). Rozpozná
// jen běžný český tvar (9 číslic, případně s +420 už zadaným) - cokoliv
// jiného (zahraniční čísla, netypický zápis) se vrátí beze změny, ne
// rozbité na půl.

function digitsWithPlus(phone) {
  return (phone || '').replace(/[^\d+]/g, '');
}

function normalizeCzech(phone) {
  const raw = digitsWithPlus(phone);
  if (/^\d{9}$/.test(raw)) return `+420${raw}`;
  if (/^\+420\d{9}$/.test(raw)) return raw;
  return null;
}

export function formatPhoneDisplay(phone) {
  const normalized = normalizeCzech(phone);
  if (!normalized) return phone || '';

  const match = normalized.match(/^(\+420)(\d{3})(\d{3})(\d{3})$/);
  return match ? `${match[1]} ${match[2]} ${match[3]} ${match[4]}` : phone;
}

export function formatPhoneHref(phone) {
  const normalized = normalizeCzech(phone);
  return normalized || digitsWithPlus(phone);
}
